import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import "./App.scss";
import "./App.css";
import AppRoutes from "./AppRoutes";
import Navbar from "./shared/Navbar";
import Sidebar from "./shared/Sidebar";
import SettingsPanel from "./shared/SettingsPanel";
import Footer from "./shared/Footer";
// Kept so re-enabling the chatbot below is a one-line uncomment.
// eslint-disable-next-line no-unused-vars
import ClaraChat from "./shared/ClaraChat";
import AppUpdateBanner from "./shared/AppUpdateBanner";
import { withTranslation } from "react-i18next";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

import moment from "moment-timezone";
moment.tz.setDefault("America/Santiago");

class App extends Component {
  state = {};
  componentDidMount() {
    this.onRouteChanged();
    this.loadActiveIssuingCompany();
  }

  // The active platform (S22) issuing company drives empresa_id on all direct
  // DTE calls — fetched once so the admin can switch issuers without redeploys.
  async loadActiveIssuingCompany() {
    if (!localStorage.getItem("accessToken")) return;
    try {
      const { getPlatformSiiCompany } = await import("./utils/APIs");
      const { setActiveEmpresaId } = await import("./utils/APIs/axios");
      const { data } = await getPlatformSiiCompany();
      if (data?.data?.empresa_id) {
        setActiveEmpresaId(data.data.empresa_id);
      }
    } catch (error) {
      console.info("Could not load active issuing company:", error?.message);
    }
  }
  render() {
    let navbarComponent = !this.state.isFullPageLayout ? <Navbar /> : "";
    let sidebarComponent = !this.state.isFullPageLayout ? <Sidebar /> : "";
    let SettingsPanelComponent = !this.state.isFullPageLayout ? (
      <SettingsPanel />
    ) : (
      ""
    );
    let footerComponent = !this.state.isFullPageLayout ? <Footer /> : "";
    return (
      <div className="container-scroller">
        <AppUpdateBanner />
        {navbarComponent}
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
        <div className="container-fluid page-body-wrapper">
          {sidebarComponent}
          <div className="main-panel">
            <div className="content-wrapper">
              {/* <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss={false}
                draggable
                pauseOnHover
              /> */}
              <AppRoutes />
              {SettingsPanelComponent}
            </div>
            {footerComponent}
          </div>
        </div>
        {/* Clara AI Chatbot — temporarily hidden so the mobile section-nav
            FAB on the product form isn't covered. Re-enable when needed. */}
        {/* {!this.state.isFullPageLayout && <ClaraChat />} */}
      </div>
    );
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.onRouteChanged();
    }
  }

  onRouteChanged() {
    console.log("ROUTE CHANGED");
    const { i18n } = this.props;
    const body = document.querySelector("body");
    if (this.props.location.pathname === "/layout/RtlLayout") {
      body.classList.add("rtl");
      i18n.changeLanguage("ar");
    } else {
      body.classList.remove("rtl");
      i18n.changeLanguage("en");
    }
    window.scrollTo(0, 0);
    const fullPageLayoutRoutes = [
      "/user-pages/login-1",
      "/user-pages/login-2",
      "/user-pages/register-1",
      "/user-pages/register-2",
      "/user-pages/lockscreen",
      "/error-pages/error-404",
      "/error-pages/error-500",
      "/general-pages/landing-page",
      "/terms-and-conditions",
      "/success-message",
      "/error-message",
      "/email-client",
      "/email-login",
    ];
    for (let i = 0; i < fullPageLayoutRoutes.length; i++) {
      if (this.props.location.pathname?.startsWith("/reset-password")) {
        this.setState({
          isFullPageLayout: true,
        });
        document
          .querySelector(".page-body-wrapper")
          .classList.add("full-page-wrapper");
        break;
      } else if (this.props.location.pathname === fullPageLayoutRoutes[i]) {
        this.setState({
          isFullPageLayout: true,
        });
        document
          .querySelector(".page-body-wrapper")
          .classList.add("full-page-wrapper");
        break;
      } else {
        this.setState({
          isFullPageLayout: false,
        });
        document
          .querySelector(".page-body-wrapper")
          .classList.remove("full-page-wrapper");
      }
    }
  }
}

export default withTranslation()(withRouter(App));
